import { isFeatureEnabled } from '../../../utils/feature-flags';
import { useUserSettings } from '../../../utils/use-user-settings';
import UserFormPage from './user-form-page';
import UserFormPageOld from './user-form-page-old';

export default function CreateUserFormPage() {
  const { features } = useUserSettings();
  const uiEnhancementFeatureEnabled = isFeatureEnabled(
    'uiEnhancementPhase2',
    features
  );

  return uiEnhancementFeatureEnabled ? <UserFormPage /> : <UserFormPageOld />;
}
